import { IModel, IViolation } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';
import { AlterRowIfCondition } from './alterRowIfCondition';
import { BaseRowModifierTransformation } from './base-row-modifier-transformation';
import { BooleanDataFlowType } from './dataflow-datatype';

@Metamodel.model({
    name: 'alterRow',
    display: [stringResources.AlterRowTransformationLabel, stringResources.AlterRowTransformationPluralLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class AlterRowTransformation extends BaseRowModifierTransformation {
    public static readonly MODEL: IModel;
    public transformationLabel = stringResources.AlterRowTransformationLabel;

    @Metamodel.attribute({
        constraint: {
            validator: AlterRowTransformation.validateExpression
        }
    })
    public ifConditions: AlterRowIfCondition[] = [];

    public static validateExpression(transformation: AlterRowTransformation, conditions?: AlterRowIfCondition[]): IViolation[] {
        const violations: IViolation[] = [];
        conditions.forEach((condition) => {
            if (condition.conditionExpression && !condition.conditionExpression.returnsCorrectType) {
                violations.push({
                    context: transformation,
                    message: () => stringResources.DataFlow_ShouldReturnBoolean
                });
            }
        });
        return violations.length ? violations : undefined;
    }

    public getExpressions(): DataFlowExpression[] {
        return this.ifConditions.map((ifCondition) => ifCondition.conditionExpression);
    }

    public createIfCondition(index?: number): AlterRowIfCondition {
        const ifCondition = Owned.create<AlterRowIfCondition>(AlterRowIfCondition.MODEL, this);
        ifCondition.conditionExpression.requiredReturnType = BooleanDataFlowType.TYPE;
        if (index === undefined || index === null) {
            this.ifConditions.push(ifCondition);
        } else {
            this.ifConditions.splice(index + 1, 0, ifCondition);
        }
        return ifCondition;
    }

    public removeIfCondition(index: number): void {
        this.ifConditions.splice(index, 1);
        if (!this.ifConditions.length) {
            this.createIfCondition();
        }
    }

    protected get descriptionMsg(): string {
        return stringResources.AlterRowDescription;
    }

    protected get noDescriptionMsg(): string {
        return stringResources.AlterRowNoExpressionDescription;
    }
}
